export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (card, cardView, cards, next, nextIdx) {
      pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E\u003Cdiv class=\"cards noprint\"\u003E";
// iterate cards || []
;(function(){
  var $$obj = cards || [];
  if ('number' == typeof $$obj.length) {
      for (var idx = 0, $$l = $$obj.length; idx < $$l; idx++) {
        var c = $$obj[idx];
pug_html = pug_html + ("\u003Cbutton" + (pug_attr("class", pug_classes(["card",{selected: c === card, "designers-card": c.designers_card}], [false,true]), false, true)+pug_attr("data-idx", idx, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = c.number) ? "" : pug_interp)));
if (c.line > 0) {
pug_html = pug_html + "\n\n(" + (pug_escape(null == (pug_interp = c.line + 1) ? "" : pug_interp)) + ")";
}
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
      }
  } else {
    var $$l = 0;
    for (var idx in $$obj) {
      $$l++;
      var c = $$obj[idx];
pug_html = pug_html + ("\u003Cbutton" + (pug_attr("class", pug_classes(["card",{selected: c === card, "designers-card": c.designers_card}], [false,true]), false, true)+pug_attr("data-idx", idx, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = c.number) ? "" : pug_interp)));
if (c.line > 0) {
pug_html = pug_html + "\n\n(" + (pug_escape(null == (pug_interp = c.line + 1) ? "" : pug_interp)) + ")";
}
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv\u003E" + (null == (pug_interp = cardView) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"noprint\"\u003E";
if (next) {
pug_html = pug_html + "\u003Cbutton" + (" class=\"card next\""+pug_attr("data-idx", nextIdx, true, true)) + "\u003ENext card: " + (pug_escape(null == (pug_interp = next.number) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "card" in locals_for_with ?
        locals_for_with.card :
        typeof card !== 'undefined' ? card : undefined, "cardView" in locals_for_with ?
        locals_for_with.cardView :
        typeof cardView !== 'undefined' ? cardView : undefined, "cards" in locals_for_with ?
        locals_for_with.cards :
        typeof cards !== 'undefined' ? cards : undefined, "next" in locals_for_with ?
        locals_for_with.next :
        typeof next !== 'undefined' ? next : undefined, "nextIdx" in locals_for_with ?
        locals_for_with.nextIdx :
        typeof nextIdx !== 'undefined' ? nextIdx : undefined));
    ;;return pug_html;}